// extracted by mini-css-extract-plugin
module.exports = {"root":"ComingSoon_root__iPMDF","presaleContainer":"ComingSoon_presaleContainer__MOdQ6","title":"ComingSoon_title__78jim","comingSoon":"ComingSoon_comingSoon__T9Z9N"};